<template>
  <div
    :class="['rail-distance-cntr', { 'mirror-cntr': parkPosition === 'DX', 'rail-distance-cntr': parkPosition === 'SX' }]"
    :style="`width:${(100 * binario.lunghezza) / maxLengthFactor}%;min-width:${(600 * binario.lunghezza) / maxLengthFactor}px; left: ${parkPosition === 'DX' ? (100 * (maxLengthTrue - binario.lunghezza)) / maxLengthFactor : 0}%`"
  >
    <div
      v-for="(distanceMarker, index) in getRailIntervalList(binario, lengthInterval)"
      :key="index"
      class="rail-distance"
      :style="`width:${distanceMarker.dm}%;font-size:${(((3 * maxLengthFactor) / 100) * lengthInterval) / maxLengthFactor}rem;`"
    >
      <span :class="{ 'mirror-text': parkPosition === 'DX' }">
        {{ distanceMarker.length }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "LengthMarker",
  props: {
    binario: {
      type: Object,
      required: true,
    },
    parkPosition: {
      type: String,
      default: "SX",
    },
    maxLengthFactor: {
      type: Number,
      default: 200,
    },
    maxLengthTrue: {
      type: Number,
      default: 200,
    },
    lengthInterval: {
      type: Number,
      default: 10,
    },
  },
  methods: {
    getRailIntervalList(binario, lengthInterval) {
      let lRes = binario.lunghezza;
      const resList = [];
      for (let i = 0; i < Math.round(binario.lunghezza / lengthInterval); i++) {
        if (lRes > lengthInterval) {
          resList.push({
            dm: (100 * lengthInterval) / binario.lunghezza,
            length: lengthInterval * (i + 1),
          });
        } else {
          resList.push({ dm: (100 * lRes) / binario.lunghezza, length: binario.lunghezza });
        }
        lRes -= lengthInterval;
      }
      return resList;
    },
  },
};
</script>

<style scoped>
.rail-distance {
  height: 55px;
  margin-top: -20px;
  float: left;
  border-right: 1px solid #aaaaaa;
  text-align: right;
  color: rgb(99, 99, 99);
  padding-right: 1px;
}
.rail-distance-cntr {
  z-index: 1;
  position: absolute;
  margin-top: 25px;
}
.mirror-cntr {
  transform: scaleX(-1);
}
.mirror-text {
  transform: scaleX(-1);
  display: inline-block;
}
</style>
